import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './features24.css'

const Features24 = (props) => {
  return (
    <div className="thq-section-padding">
      <div className="features24-container2 thq-section-max-width">
        <div className="features24-image-container">
          <img
            alt={props.feature1ImgAlt}
            src={props.feature1ImgSrc}
            className="features24-image1 thq-img-ratio-16-9"
          />
        </div>
        <div className="features24-tabs-menu">
          <div className="features24-tab-horizontal1">
            <div className="features24-divider-container1">
              <div className="features24-container3"></div>
            </div>
            <div className="features24-content1">
              <h2 className="thq-heading-2">
                {props.feature1Title ?? (
                  <Fragment>
                    <span className="features24-text2">
                      Personalized Training Sessions
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="thq-body-small">
                {props.feature1Description ?? (
                  <Fragment>
                    <span className="features24-text3">
                      One-on-one training sessions with Adrian for maximum
                      results
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="features24-tab-horizontal2">
            <div className="features24-divider-container2">
              <div className="features24-container4"></div>
            </div>
            <div className="features24-content2">
              <span className="thq-body-small">
                {props.feature2Description ?? (
                  <Fragment>
                    <span className="features24-text1">
                      Nutritional guidance and meal planning to support fitness
                      goals
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="features24-tab-horizontal3">
            <div className="features24-divider-container3">
              <div className="features24-container5"></div>
            </div>
            <div className="features24-content3">
              <span className="thq-body-small">
                {props.feature3Description ?? (
                  <Fragment>
                    <span className="features24-text4">
                      Personalized workout plans tailored to individual goals
                      and needs
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Features24.defaultProps = {
  feature1ImgAlt: 'Adrian training a client in the gym',
  feature2Description: undefined,
  feature1Title: undefined,
  feature1Description: undefined,
  feature1ImgSrc:
    'https://images.unsplash.com/photo-1517838277536-f5f99be501cd?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDM4fHxmaXRuZXNzfGVufDB8fHx8MTcyOTQwNjc4OXww&ixlib=rb-4.0.3&w=1400',
  feature3Description: undefined,
}

Features24.propTypes = {
  feature1ImgAlt: PropTypes.string,
  feature2Description: PropTypes.element,
  feature1Title: PropTypes.element,
  feature1Description: PropTypes.element,
  feature1ImgSrc: PropTypes.string,
  feature3Description: PropTypes.element,
}

export default Features24
